import { MedicalPlanDto } from '@zorro/clients';
import { parseDateISO } from '@zorro/shared/formatters';

import { useEmployerFeatureFlag } from './useEmployerFeatureFlag';
import { useMonolithQuery } from './useMonolithQuery';

type Props = {
  employeeId: string;
  employerId?: string;
  plan: MedicalPlanDto | null | undefined;
  onboardingPeriodId: string;
};

export const usePlanAttestations = ({
  employeeId,
  employerId,
  plan,
  onboardingPeriodId,
}: Props) => {
  const { isOn: isEnabled, isReady: isFlagReady } = useEmployerFeatureFlag(
    'carrier_attestations_enabled',
    employerId
  );

  const { data: onboardingPeriod, isLoading: isLoadingPeriod } =
    useMonolithQuery({
      method: 'onboardingPeriodsControllerFindOne',
      params: [employeeId, onboardingPeriodId],
      enabled: isEnabled,
    });

  const hiosId = plan?.externalID;
  const effectiveFrom = onboardingPeriod?.effectiveFrom;
  const planYear = effectiveFrom && parseDateISO(effectiveFrom).year();

  const { data: attestations, isLoading: isLoadingAttestations } =
    useMonolithQuery({
      method: 'applicationsControllerGetPlanAttestations',
      params: isEnabled && hiosId && planYear && [hiosId, planYear],
      enabled: Boolean(isEnabled && hiosId && planYear),
    });

  return {
    attestations,
    effectiveFrom,
    // True until we can tell whether an attestation is required - an
    // unresolved flag reads as off, which callers must not treat as "none".
    isLoading:
      !isFlagReady || (isEnabled && (isLoadingPeriod || isLoadingAttestations)),
  };
};
